import { Attr, BelongsTo, Model } from "spraypaint";

import { SocialPlatform } from "shared/constants/social";
import { ApplicationRecord } from "shared/services/spraypaint";
import type { Nullable } from "shared/types";

import type Organisation from "./Organisation";
import { type SocialMetadata } from "./SocialMetadata";

@Model({ apiNamespace: "/social_integrations", endpoint: "/facebook" })
class FacebookSocialIntegration extends ApplicationRecord {
  static jsonapiType = "facebook_social_integrations";

  @Attr({ persist: false }) archived: boolean;

  @Attr() archivedAt: string;

  @Attr() draftPosts: number;

  @Attr() expiredAt: Nullable<string>;

  @Attr() expiresAt: Nullable<string>;

  @Attr() isSocialEngage: boolean;

  @Attr() isSocialListen: boolean;

  @Attr() label: string;

  @Attr() metadata: SocialMetadata;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() organisationTeamIds: number[];

  @Attr() permissions: string;

  @Attr() remoteId: string;

  @Attr() scheduledPosts: number;

  @Attr() socialPlatform: string;

  @Attr() token: string;

  @Attr({ persist: false }) tokenRefreshedAt: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() validUntil: Nullable<string>;

  platformIcon(whiteIcon = false) {
    const format = whiteIcon ? "15x15" : "";

    return `${import.meta.env.VITE_ASSETS_URL}/icons/facebook${format}.svg`;
  }

  platformLabel(): SocialPlatform.FACEBOOK {
    return SocialPlatform.FACEBOOK;
  }
}

export default FacebookSocialIntegration;
